import React, { Component } from "react";
import PropTypes from "prop-types";
//import classNames from "classnames";
import { ParallaxProvider } from "react-scroll-parallax";

// Mui Components
import { withStyles } from "@material-ui/core/styles";
//import Typography from "@material-ui/core/Typography";

// App Components
import PageRouter from "./routes/PageRouter";

// App Assets
//import appTheme from "./assets/jss/theme";
import "./public/index.css";

const styles = theme => ({
  root: {
    //overflow: "visible"
  }
});

class App extends Component {
  state = {
    drawerOpen: false
  };

  handleDrawerOpen = () => {
    this.setState({ drawerOpen: true });
  };

  handleDrawerClose = () => {
    this.setState({ drawerOpen: false });
  };

  handleDrawerToggle = () => {
    if (!this.state.drawerOpen) {
      this.setState({ drawerOpen: true });
    } else {
      this.setState({ drawerOpen: false });
    }
  };

  componentDidMount() {
    //console.log("app mounted: " + moment());
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <ParallaxProvider>
          <PageRouter />
        </ParallaxProvider>
      </div>
    );
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(App);



// WEBPACK FOOTER //
// ./src/App.js